module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_c07-d35ec2f5e8afe97c5ca3edab057c143e.jpg";